export default __webpack_public_path__ + "static/media/loginDotGovLogo.5c5dfc13461f63615a1aff43cad186f8.svg";